@if (seConfiguration) {
  <div class="cell small-12">
    <label>Type of Identifier:
      <select name="selUserSideEffect" [(ngModel)]="seConfiguration.identifierType" >
        @for (option of identifierTypes; track option) {
          <option [value]="option">{{option}}</option>
        }
      </select>
    </label>
  </div>
}

<div class="grid-x grid-margin-x">
  <div class="cell small-12">
    <label>Context Target:
      <input type="text" [(ngModel)]="seConfiguration.contextTarget" />
    </label>
    <span class="tiny">Please don't change this from $.data.applicationNumber.value unless you have a good reason.
    Otherwise work orders will not populate the value correctly, and it will not appear in views/widgets.</span>
  </div>
</div>